document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll(".read-more-btn");

  // Functie om tekst in te korten naar 2 regels
  function truncateParagraph(p) {
    const fullText = p.dataset.fulltext || p.textContent.trim();
    p.dataset.fulltext = fullText;

    const lineHeight = parseFloat(window.getComputedStyle(p).lineHeight);
    const maxHeight = lineHeight * 2; 

    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.width = `${p.offsetWidth}px`;
    tempSpan.style.font = window.getComputedStyle(p).font;
    tempSpan.style.lineHeight = window.getComputedStyle(p).lineHeight;
    document.body.appendChild(tempSpan);

    let words = fullText.split(' ');
    let low = 0, high = words.length, fitText = '';

    while (low <= high) {
      let mid = Math.floor((low + high) / 2);
      tempSpan.textContent = words.slice(0, mid).join(' ') + '...';
      if (tempSpan.offsetHeight <= maxHeight) {
        fitText = tempSpan.textContent;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    p.textContent = fitText || fullText;
    document.body.removeChild(tempSpan);
  }

  // Initialiseer alle previews op 2 regels
  document.querySelectorAll('.read-more-preview p').forEach(p => {
    truncateParagraph(p);
  });

  buttons.forEach(btn => {
    btn.addEventListener("click", function() {
      const container = btn.previousElementSibling; 
      const content = container.querySelector(".read-more-content");
      const previewPara = container.querySelector(".read-more-preview p");

      const isOpen = content.style.display === "block";

      if (isOpen) {
        // DICHTKLAPPEN
        content.style.display = "none";
        truncateParagraph(previewPara); // Terug naar 2 regels
        btn.textContent = window.readMoreText;
      } else {
        // OPENKLAPPEN
        content.style.display = "block";
        previewPara.textContent = previewPara.dataset.fulltext; // Terug naar volledige eerste alinea
        btn.textContent = window.readLessText;
      }
    });
  });
});